import React from "react";
import { useDispatch } from "react-redux";
import { Creators } from "@Src/redux/actionTypes";
import Loading from "@Components/loading";

const GetPreferences = ({ children }) => {
  const [readyToContinue, setReadyToContinue] = React.useState(false);
  const dispatch = useDispatch();

  // lets the ui start rendering, and initializes the preferences stuff
  const getPrefs = React.useCallback(() => {
    setReadyToContinue(true);
    // calling getPreferences here sets up a new prefs session object on the server for new sessions,
    // and gets the current preferences set on the session for existing ones - e.g. during a hard reload.
    dispatch(Creators.getPreferences({}));
  }, [dispatch, setReadyToContinue]);

  // fire off the get prefs request
  React.useEffect(() => {
    if (!readyToContinue) {
      getPrefs();
    }
  }, [readyToContinue, getPrefs]);

  if (!readyToContinue) {
    return <Loading />;
  }
  return children;
};

export default GetPreferences;
